import { AuthService } from "../service/auth.service";
import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { TokenCookieService } from "../service/token-storage-cookies.service";
import { Router } from "@angular/router";
import { SnackbarService } from "src/app/shared/services/snackbar.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private tokenCookieService: TokenCookieService,
    private snackbar: SnackbarService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const message = this.resolveErrorMessage(err);
        this.snackbar.showNotification("snackbar-danger", message);

        return throwError(() => err);
      })
    );
  }

  private resolveErrorMessage(err: HttpErrorResponse): string {
    if (err.status === 0) {
      // No response reached the browser at all — server down, CORS, or network issue
      return "Please check your connection or try again shortly.";
    }
    if (err.status >= 500) {
      return "The server encountered an error. Please try again shortly.";
    }
    if (err.error?.message) {
      // Use the backend's own error message when it sent one
      return err.error.message;
    }
    return err.statusText || "Something went wrong. Please try again.";
  }

  
}